import useVerifyCaptchaPublicWizard from './useVerifyCaptchaPublicWizard'

export default useVerifyCaptchaPublicWizard
